module.exports = __webpack_public_path__ + "img/vpc3.9bf33fe.png";